/**
 * Deal Analyzer embed — wraps DealIntelligenceDemo in a bare shell.
 */
import React from "react";
import EmbedShell from "@/pages/embed/EmbedShell";
import DealIntelligenceDemo from "@/components/forge-vision/DealIntelligenceDemo";

export default function DealAnalyzerEmbed() {
    return (
        <EmbedShell kind="deal_analyzer">
            <DealIntelligenceDemo />
        </EmbedShell>
    );
}
